import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import AddIcon from '@material-ui/icons/Add';
import { Circle } from '@mui/icons-material';
import SideBarListStyles from '../../styles/SideBarListStyle';
import { getDealershipList, getDealershipID, showProgress } from '../../redux/actions/DealershipActions';
import { DealershipAddnewPopup } from '../dealership/DealershipAddnewPopup';
import ShowProgress from '../ui/Backdrop';
import FloatButton from './FloatButton';
import GetDealerships from '../../apis/GetDealerships';
import ReactInfiniteScroll from '../common/ReactInfiniteScroll';
import useFetchDetails from '../dealership/hooks/useFetchDetails';

export default function SelectedListItem(props) {
  const classes = SideBarListStyles();
  const { fetchDetails } = useFetchDetails();
  const [selectedIndex, setSelectedIndex] = useState();
  const [isAddnewPopupOpen, setIsAddnewPopupOpen] = useState(false);

  const dealershipID = useSelector((state) => state.getDealershipID);
  const value = props.value === undefined ? 0 : props.value;

  let dealershipId = useRef(0);
  const dispatch = useDispatch();
  const myRef = props.filterArray?.reduce((acc, val) => {
    acc[val.id] = React.createRef();
    return acc;
  }, {});

  useEffect(() => {
    fetchDataList();
  }, []);
  useEffect(() => {
    if (myRef && myRef[dealershipID]?.current) {
      myRef[dealershipID]?.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  }, [dealershipID, myRef]);
  const fetchDataList = async () => {
    const data = await GetDealerships();
    dealershipId = data[0].id;
    dispatch(getDealershipList('get', data));
    dispatch(getDealershipID(data[0].id));
    handleListItemClick(0, dealershipId);
  };
  const handleListItemClick = async (event, index) => {
    setSelectedIndex(index);
    dispatch(showProgress(true));
    fetchDetails(index);
  };

  const fabs = [
    {
      color: 'primary',
      className: classes.fab,
      icon: <AddIcon />,
      label: 'Add',
    },
    {
      color: 'primary',
      className: classes.fab,
      icon: <AddIcon />,
      label: 'Add',
    },
  ];

  const addNewDealership = () => {
    setIsAddnewPopupOpen(true);
  };

  const closeAddNewDealership = () => {
    setIsAddnewPopupOpen(false);
  };

  const renderDealershipItem = (data) => {
    const index = data.id;
    return (
      <div key={data.id} className={selectedIndex === index ? classes.highlightItem : ''} style={{ width: '100%' }}>
        <ListItem
          button
          ref={myRef[data.id]}
          selected={selectedIndex === index}
          className={classes.listStyling}
          style={{ maxWidth: '14vw' }}
          onClick={(event) => handleListItemClick(event, index)}
        >
          <ListItemText
            primary={
              <div className={selectedIndex === index ? classes.listTextSelected : classes.listTextNonSelected}>
                {data.name}
              </div>
            }
            secondary={
              <div className={selectedIndex === index ? classes.listSubTextSelected : classes.listSubTextNonSelected}>
                <p className={classes.listItemId}>ID: {data?.id}</p>
                <p
                  style={{
                    fontSize: '10px',
                    marginTop: '-10px',
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    gap: '5px',
                  }}
                >
                  <div>{`${data.employeesCount || 0} Employees`}</div>
                  <Circle style={{ fontSize: '8px', color: 'gray' }} />
                  <div className={!data.enabled ? classes.secondaryTextRed : null}>
                    {data.enabled ? 'Enabled' : 'Disabled'}
                  </div>
                </p>
              </div>
            }
          />
        </ListItem>
      </div>
    );
  };

  return (
    <div className={classes.root}>
      <ReactInfiniteScroll size={20} data={props.filterArray || []} height="54vh" renderItem={renderDealershipItem} />
      <FloatButton fabs={fabs} value={value} mainTabID={1} onaddNewDealership={addNewDealership} />
      {isAddnewPopupOpen && (
        <DealershipAddnewPopup
          open
          close={closeAddNewDealership}
          add
          getSelect={handleListItemClick}
          refreshData={fetchDataList}
        />
      )}
      <ShowProgress />
    </div>
  );
}
